















































































































































































































import { Component, Inject, Mixins } from "vue-property-decorator";
import { AdminRoutes, RegexMatch } from "@/data/enums/router";
import { BrandConfigKeys, QUERY_PARAMS } from "@/data/constants";
import {
  IClientProviderData,
  IClientProviderMethods
} from "@/models/providers/client";
import ClientMixin from "@/mixins/clientMixin";
import { DataModules } from "@/store/modules/data";
import { IInvoice } from "@/models/invoices";
import { mapState } from "vuex";
import { IState } from "@/store";
import { CreateElement } from "vue";

@Component({
  components: {
    "fraud-status": () =>
      import("@/components/app/global/fraud/fraudStatus.vue"),
    "client-tags": () =>
      import("@/components/app/global/client/clientTags.vue"),
    "client-support-pin-message": () =>
      import("@/components/app/global/client/clientSupportPinMessage.vue")
  },
  computed: {
    ...mapState({
      isSupportPinEnabled(state: IState) {
        return state.brand.config[BrandConfigKeys.SUPPORT_PIN_ENABLED];
      }
    })
  }
})
export default class ClientProfileCard extends Mixins(ClientMixin) {
  // Inject

  @Inject({ from: "clientProvider" })
  public readonly $clientProvider!: () => IClientProviderData;

  @Inject({ from: "clientMethods" })
  public readonly $clientMethods!: IClientProviderMethods;

  // Data
  public readonly isSupportPinEnabled!: boolean;

  // Computed

  public get $clientData() {
    return this.$clientProvider();
  }

  public get adminOrderRoute() {
    return {
      name: "adminOrderShop",
      params: { basketId: RegexMatch.NEW },
      query: {
        [QUERY_PARAMS.CLIENT_ID]: this.$clientData.clientId,
        [QUERY_PARAMS.ACCOUNT_ID]: this.$clientData.accountId
      }
    };
  }

  public get accountType() {
    const {
      id: clientId,
      parent_client_config,
      child_client_configs_count
    } = this.$clientData.client;
    // IS Child Account
    if (parent_client_config)
      return {
        render: (h: CreateElement) =>
          h(
            "i18n",
            {
              props: {
                path: "_sentence.related_accounts.child_of_parent"
              }
            },
            [
              h(
                "u-link",
                {
                  slot: "parent",
                  on: {
                    click: () => this.$clientMethods.manageParentRelation()
                  }
                },
                parent_client_config?.parent_client?.public_name
              )
            ]
          )
      };
    // IS Parent Account
    if (child_client_configs_count)
      return {
        render: (h: CreateElement) =>
          h(
            "i18n",
            {
              props: {
                path: "_sentence.parent_with_children_link"
              }
            },
            [
              h(
                "u-link",
                {
                  slot: "childLink",
                  props: {
                    to: {
                      name: AdminRoutes.CLIENT_ACCOUNTS_CHILD_ACCOUNTS,
                      params: { clientId }
                    }
                  }
                },
                [this.$tc("_plurals.children", child_client_configs_count)]
              )
            ]
          )
      };
    return null;
  }

  public get securitySettingsRoute() {
    return {
      name: AdminRoutes.CLIENT_SETTINGS_SECURITY
    };
  }

  public get referrerClientLink() {
    const referrer = this.$clientData?.client?.affiliate_referral
      ?.affiliate_account?.account?.client?.[0];
    if (!referrer) return null;
    return {
      render: (h: CreateElement) =>
        h(
          "u-link",
          {
            props: {
              to: {
                name: AdminRoutes.CLIENT_ACCOUNTS_AFFILIATE_ACCOUNT_OVERVIEW,
                params: {
                  clientId: referrer.id
                }
              }
            }
          },
          referrer.public_name
        )
    };
  }

  /**
   * @name showUsername
   * @desc Here we determine whether or not to show the client's username. If the
   * username is identical to their default email we won't show the username
   * field as it just adds duplicate data. */

  public get showUsername() {
    if (!this.$clientData.client?.has_login) return true;
    const { default_email, username } = this.$clientData.client;
    if (default_email?.email === username) return false;
    return true;
  }

  // Methods

  public openNewTicketModal() {
    this.$store.dispatch(
      "data/tickets/openNewTicketModal",
      this.$_.pick(this.$clientData, ["clientId", "accountId", "brandId"])
    );
  }

  public placeNewQuickOrder() {
    this.$store.dispatch(`data/${DataModules.BASKETS}/openQuickOrderModal`, {
      props: {
        clientId: this.$clientData.clientId,
        accountId: this.$clientData.accountId
      },
      events: {
        success: (invoice: IInvoice) => {
          this.$router.push(
            this.$store.getters[`data/${DataModules.INVOICES}/getRoute`](
              invoice.id,
              invoice.client_id
            )
          );
        }
      }
    });
  }
}
